import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { isDefined } from "@omni/utils/helper.utils";
import equal from "fast-deep-equal";
import { sumBy } from "lodash-es";
import { createContext, use } from "react";
import { useSelector } from "react-redux";

import { getComponentsState } from "@/redux/modules/value/search/search.selectors";
import { SearchComponentStateMap } from "@/utils/search/types/searchState";

import { NumberOfHitsConfiguration } from "../numberOfHits.config";

export type NumberOfHitsContextValue = {
    state: (
        | SearchComponentStateMap["PRODUCT_NUMBER_OF_HITS"]
        | SearchComponentStateMap["CONTENT_NUMBER_OF_HITS"]
        | undefined
    )[];
};

type NumberOfHitsContextProviderProps = RequireChildrenFor<{}>;

export const NumberOfHitsContext = createContext<
    NumberOfHitsContextValue | undefined
>(undefined);
NumberOfHitsContext.displayName = "NumberOfHitsContext";

export const NumberOfHitsContextProvider = ({
    children
}: NumberOfHitsContextProviderProps) => {
    const state = useSelector(
        getComponentsState(
            NumberOfHitsConfiguration.map(
                (configurationEntry) => configurationEntry.component
            )
        ),
        equal
    );

    const totalNumberOfHits = sumBy(
        state,
        (numberOfHitsComponentState) =>
            numberOfHitsComponentState?.numberOfHits ?? 0
    );

    if (!totalNumberOfHits) return null;

    return (
        <NumberOfHitsContext
            value={{
                state
            }}
        >
            {children}
        </NumberOfHitsContext>
    );
};

export const useNumberOfHitsContext = () => {
    const context = use<NumberOfHitsContextValue | undefined>(
        NumberOfHitsContext
    );

    if (!isDefined(context)) {
        throw new Error(`${NumberOfHitsContext.displayName} is undefined.`);
    }

    return context;
};
